import { render, staticRenderFns } from "./AddEditLoan.vue?vue&type=template&id=0f81382c"
import script from "./AddEditLoan.vue?vue&type=script&lang=js"
export * from "./AddEditLoan.vue?vue&type=script&lang=js"
import style0 from "./AddEditLoan.vue?vue&type=style&index=0&id=0f81382c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports